import { DatePipe } from '@angular/common';
import { ConditionalExpr } from '@angular/compiler';
import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { AclTipo } from 'src/app/model/AclTipo.enum';
import { AnomalieSegnalazioneDataSource } from 'src/app/services/anomalie-segnalazione.datasource';
import { SegnalazioniService } from 'src/app/services/segnalazioni.service';

@Component({
  selector: 'app-anomalie-segnalazione-dialog',
  templateUrl: './anomalie-segnalazione-dialog.component.html',
  styleUrls: ['./anomalie-segnalazione-dialog.component.css']
})
export class AnomalieSegnalazioneDialogComponent implements OnInit, AfterViewInit {

  public form: FormGroup
  public isDpgr: boolean = false;
  public stringDpgr: string;
  dataSource: AnomalieSegnalazioneDataSource;
  displayedColumns: string[] = ['motivazioneRifiuto', 'dataRifiuto'];
  public acl: string;
  private codiceSegnalazione: number;
  public showMessage: string = '';
  public lastMessage:string = '';
  public lastDate:Date;
  public showDate:Date;
  public showTable: boolean = false;


  constructor(
    public dialogRef: MatDialogRef<AnomalieSegnalazioneDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModelEventiCalamitosi.DialogData,
    private segnalazioneService: SegnalazioniService,
    public datePipe: DatePipe,
    private alertsCenterService: AlertsCenterService
  ) {

    this.acl = sessionStorage.getItem('acl');
    if (this.acl !== AclTipo.EELL) this.displayedColumns.push('utenteRifiuto')
    this.loadMessaggiErrore(this.data.codiceSegnalazione);

  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
  }

  // onNoClick(): void {
  //   this.dialogRef.close();
  // }

  loadMessaggiErrore(codiceSegnalazione: number) {

    this.dataSource = new AnomalieSegnalazioneDataSource(this.segnalazioneService);
    this.dataSource.errors$.subscribe(res => {
      if (res) this.alertsCenterService.showAlert({
        message: `Errore lettura dati`,
        type: 'danger',
        autoClosable: false
      });
    })
    this.segnalazioneService.getListAnomalieSegnalazione(codiceSegnalazione, true).subscribe(result => {
      this.showMessage = result[0].motivazioneRifiuto;
      this.showDate = result[0].dataConfermaRifiuto
      this.lastMessage = result[0].motivazioneRifiuto;
      this.lastDate = result[0].dataConfermaRifiuto;
    }
    );

  }

  onShowTab() {
    this.showTable = !this.showTable;
    if (this.showTable) {
      this.dataSource.loadListAnomalieSegnalazione(this.data.codiceSegnalazione, false);
    }
    else {
      this.showMessage = this.lastMessage;
      this.showDate = this.lastDate;
    }
  }

  onShowMessage(mess:string,data:Date) {
    this.showMessage = mess;
    this.showDate = data;
  }

}


